import { render } from "./PageAdmin.vue?vue&type=template&id=4f7b59b4&scoped=true"
import script from "./PageAdmin.vue?vue&type=script&lang=ts"
export * from "./PageAdmin.vue?vue&type=script&lang=ts"

import "./PageAdmin.vue?vue&type=style&index=0&id=4f7b59b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f7b59b4"

export default script